"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _List = _interopRequireDefault(require("./List"));

exports["default"] = _List["default"];